import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  getCountryListOptions,
  getNationalityListOptions,
} from '../../constants/countryList';
import { FORM_FIELD_TYPE_CODE } from '../../constants/formElements';
import {
  getTranslation,
  getMatchingOptionsLabels,
} from '../../utils/functions';
import 'datejs';

export const formatData = ({
  fieldCode,
  providedValue,
  typeCode,
  values,
  eventsList,
  fieldsData,
  formSessionDropdownList,
  useApiForOptions,
}) => {
  if (providedValue === '') {
    return '-';
  }

  switch (typeCode) {
    case FORM_FIELD_TYPE_CODE.TOGGLE_BUTTON:
    case FORM_FIELD_TYPE_CODE.CHECKBOX:
    case FORM_FIELD_TYPE_CODE.NATIVE_RESIDENT_SELECT:
      return getTranslation(providedValue ? 'YES' : 'NO');

    case FORM_FIELD_TYPE_CODE.PHONE_NUMBER:
      return (
        parsePhoneNumberFromString(providedValue)?.formatInternational() ||
        providedValue ||
        '-'
      );

    case FORM_FIELD_TYPE_CODE.DROPDOWN: {
      if (useApiForOptions) {
        const apiOption = formSessionDropdownList[fieldCode];

        if (Array.isArray(providedValue)) {
          // Handle multi-select with API options
          const selectedOptions = providedValue.map((value) => {
            const selectedOption =
              apiOption &&
              apiOption.length > 0 &&
              apiOption?.find((option) => option.value === value);
            return selectedOption?.label || value;
          });
          return selectedOptions.join(', ');
        } else {
          // Handle single select with API options
          const selectedOption =
            apiOption &&
            apiOption.length > 0 &&
            apiOption?.find((option) => option.value === providedValue);
          return selectedOption?.label;
        }
      }

      if (Array.isArray(providedValue)) {
        // Handle multi-select with static options
        const translatedValues = providedValue.map((value) => {
          const choosenOption = values.find((option) => option.key === value);
          return getTranslation(choosenOption?.value) || value;
        });
        return translatedValues.join(', ');
      } else {
        // Handle single select with static options
        const choosenOption = values.find(
          (option) => option.key === providedValue,
        );
        return getTranslation(choosenOption?.value);
      }
    }

    case FORM_FIELD_TYPE_CODE.RADIO_BUTTONS: {
      const choosenOption = values.find(
        (option) => option.key === providedValue,
      );
      return getTranslation(choosenOption?.value);
    }

    case FORM_FIELD_TYPE_CODE.EVENT_MULTI_SELECT: {
      if (providedValue && providedValue.length > 0) {
        const choosenOption = getMatchingOptionsLabels(
          eventsList,
          providedValue,
        );
        return getTranslation(choosenOption?.join(', '));
      }
      return '-';
    }

    case FORM_FIELD_TYPE_CODE.DATE_PICKER: {
      if (!providedValue) return '-';
      return new Date(providedValue).toString('dd.MM.yyyy');
    }

    case FORM_FIELD_TYPE_CODE.COUNTRY_SELECT_OR_WRITE: {
      return getCountryListOptions().find(
        (country) => country.key === providedValue,
      )?.label;

      // return providedValue.name;
    }

    case FORM_FIELD_TYPE_CODE.COUNTRY_SELECT: {
      return getCountryListOptions().find(
        (country) => country.key === providedValue,
      )?.label;
    }

    case FORM_FIELD_TYPE_CODE.STATE_MULTI_SELECT: {
      if (
        providedValue &&
        providedValue.length > 0 &&
        fieldsData.nativeResident
      ) {
        if (Array.isArray(providedValue)) {
          return providedValue?.join(', ');
        }
        return providedValue.split(',').join(', ');
      }
      return '-';
    }

    case FORM_FIELD_TYPE_CODE.NATIONALITY_SELECT: {
      return getNationalityListOptions().find(
        (country) => country.key === providedValue,
      )?.label;
    }

    default:
      return providedValue;
  }
};
